import { call, put, takeLatest } from "redux-saga/effects";
import { actions, IQuizRequestParams } from "../type";
import * as Sentry from "@sentry/react";
import {
  requestQuizById,
  getQuizProgress,
  updateQuizProgressRequest,
  notifyError,
  getCustomQuiz,
} from "../api";
import { saveQuizData, toggleLoading } from "../actions/quiz";
import { quizId, userId } from "../utils/constants";
import get from "lodash/get";
import pick from "lodash/pick";

function* makeQuizDataRequest(action: {
  type: string;
  payload: IQuizRequestParams;
}) {
  try {
    const quizDataResponse = yield call(requestQuizById, action.payload);

    const quizData = quizDataResponse.data;
    const customQuizResponse = yield call(getCustomQuiz, {
      quizID: Number(quizId),
      userID: userId,
    });
    const quizProgressResponse = yield call(getQuizProgress, {
      quizID: Number(quizId),
      userID: userId,
    });
    const selectedQuestionsObj = get(
      customQuizResponse.data,
      "questionInfo.questions",
      {}
    );
    const clonedQuestions = quizData.questions;
    let customSelectedIds: number[] = [];
    const selectedQuestions = clonedQuestions.filter((question) => {
      const isSelected = get(selectedQuestionsObj, `${[question._id]}`, true);
      if (isSelected) {
        customSelectedIds = [...customSelectedIds, question._id];
        return question;
      }
    });
    if (selectedQuestions.length) {
      quizData.questions = selectedQuestions;
    }
    quizData.questions.forEach((question: any) => {
      question.retries = question.retries + 1;
    });
    const progressData = quizProgressResponse.data.data;
    if (progressData) {
      const { progress } = progressData;
      let { answers, attempts, flags } = progress;
      let unsolvedId = 0.1;
      let firstUnTouch = 0.1;
      if (quizData.questions.length > 0) {
        quizData.questions.map((question: any, index: number) => {
          const ansData = get(answers, `${question._id}`, null);
          const attemptData = get(attempts, `${question._id}`, null);
          if (question._answerType === "sort_answer" || question._answerType ==="matrix_sort_answer") {
            if (question._answerData.length) {
              question._answerData = question._answerData.map((ans: any, i) => {
                let _inputId = null
                if(ansData?.answerVal?.length>0){
                const inputAns = ansData?.answerVal?.find(an => an?._id === i)
                if(inputAns){
                  _inputId = inputAns?._inputId
                }
                }               
                return { ...ans, _id: i,_inputId:_inputId };
              });
            }
          }
         
          
          if (ansData === null || ansData.ans === null) {
            if (firstUnTouch === 0.1) {
              firstUnTouch = index;
            }
            answers[question._id] = { ans: null, answerVal: "", duration: 0 };
          }
          if (attemptData === null) {
            attempts[question._id] = question.retries;
          }
          if (ansData && ansData.ans === false && attemptData !== 0) {
            if (unsolvedId === 0.1) {
              unsolvedId = index;
            }
          }
          question.sortIndex = index;
          return question;
        });
        unsolvedId = unsolvedId === 0.1 ? firstUnTouch : unsolvedId;
        if (customSelectedIds.length) {
          answers = pick(answers, customSelectedIds);
          attempts = pick(attempts, customSelectedIds);
          flags = customSelectedIds.filter((id) => {
            return flags.includes(id);
          });
        }
        progress.answers = answers;
        progress.attempts = attempts;
        quizData.firstUnsolvedId = unsolvedId;
      }
      yield put(saveQuizData({ quizData, progressData }));
    } else {
      if (quizData.questions.length > 0) {
        quizData.questions.map((question: any, index: number) => {
          if (question._answerType === "sort_answer" || question._answerType ==="matrix_sort_answer") {
            if (question._answerData.length) {
              question._answerData = question._answerData.map((ans: any, i) => {
                return { ...ans, _id: i,_inputId:null };
              });
            }
          }
          question.sortIndex = index;
          return question;
        });
      }
      yield put(saveQuizData({ quizData, progressData }));
    }
    yield Sentry.setContext("quiz", {
      quiz: quizData.questions,
    });
    yield Sentry.setContext("progress", {
      progress: progressData,
    });
  } catch (err) {
    notifyError("Something went wrong, please try again");
  }
}

function* makeUpdateProgressRequest(action: { type: string; payload: any }) {
  try {
    if (action.payload && action.payload.progress) {
      yield Sentry.setContext("progress", {
        progress: action.payload.progress,
      });
    }
    yield call(updateQuizProgressRequest, action.payload);
    yield put(toggleLoading(false));
  } catch (err) {
  }
}

export default [
  takeLatest(actions.REQUEST_QUIZ_DATA, makeQuizDataRequest),
  takeLatest(actions.UPDATE_QUIZ_PROGRESS, makeUpdateProgressRequest),
];
